import React, { useState, useEffect } from "react";
import config from "../../config";
import jsPDF from 'jspdf';
import 'jspdf-autotable';

//components
import PageTitle from "../../components/PageTitle/PageTitle";
import { CircularProgress, TextField } from "@material-ui/core";
import Modal from "../modals/Modal";
import {
  IconButton,
  Select,
  FormControl,
  MenuItem
} from "@material-ui/core";
import SnackbarMessage from "../modals/SnackbarMessage";
import {
  CloudDownload as Download,
} from "@material-ui/icons";

// styles
import useStyles from "./styles";
import useStylesTable from "../products/styles";

const CashOutReport = () => {
  const classes = useStyles();
  const classesTable = useStylesTable();

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [messageSnackbar, setMessageSnackbar] = useState(false);
  const [errorSnackbar, setErrorSnackbar] = useState(false);

  const [cashOut, setCashOut] = useState(null);
  const [dateOne, setDateOne] = useState(null);
  const [casher, setCasher] = useState({ id: '', name: '' });
  const [allCasher, setAllCasher] = useState([]);

  const closeModalLogin = e => {
    setShowModal(false);
  }

  const fetchCashers = async () => {
    fetch(baseUrl + "cashers",
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        if (data.error == null) {
          setAllCasher(data);
        } else {
          setShowModal(true);
        }
        setIsLoading(false);
      }).catch(error => setIsLoading(false));
  }

  useEffect(() => {
    fetchCashers();
  }, []);

  function currencyFormat(num) {
    return '$ ' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }

  const handleToClose = (event, reason) => {
    if ("clickaway" == reason) return;
    setShowSnackbar(false);
  };

  const fetchCashOut = async (body) => {
    fetch(baseUrl + "cashOutByDate",
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
        body: JSON.stringify(body)
      }).then(response => response.json())
      .then(data => {
        if (data.status == "Ok") {
          if (data.content != "No hay registro" && data.content != "Llena los filtros de búsqueda") {
            setCashOut(data.content);
          } else {
            setCashOut(null);
            setMessageSnackbar(data.content);
            setErrorSnackbar(true);
            setShowSnackbar(true);
          }
        } else {
          setShowModal(true);
        }
      }).catch(error => null);
  }

  const onChangeDateOne = (e) => {
    setDateOne(e.target.value);
  }

  const onClickRange = (e) => {
    const body = {
      dateOne: dateOne, casherId: casher.id
    };

    fetchCashOut(body);
  }

  const onClickSave = () => {
    var doc = new jsPDF()
    var totalPagesExp = '{total_pages_count_string}';

    doc.text('Corte de caja - KochulGym', 14, 20);

    doc.autoTable({
      columns: [
        { dataKey: 'casher', header: '' },
        { dataKey: 'date', header: '' },
      ],
      body: bodyRowsCasher(),
      startY: 30,
      showHead: 'firstPage',
      styles: { overflow: 'hidden' },
      margin: { right: 107 },
    });

    doc.autoTable({
      columns: [
        { dataKey: 'currency', header: 'Denominación' },
        { dataKey: 'amount', header: 'Cantidad' },
      ],
      body: bodyRowsTableOneCurrency(),
      startY: 40,
      showHead: 'firstPage',
      styles: { overflow: 'hidden' },
      margin: { right: 107 },
    });

    doc.autoTable({
      columns: [
        { dataKey: 'currency', header: 'Denominación' },
        { dataKey: 'amount', header: 'Cantidad' },
      ],
      body: bodyRowsTableTwoCurrency(),
      startY: 40,
      showHead: 'firstPage',
      styles: { overflow: 'hidden' },
      margin: { left: 107 },
    });

    doc.autoTable({
      columns: [
        { dataKey: 'currency', header: '' },
        { dataKey: 'amount', header: '' },
      ],
      body: bodyRowsMiddleOne(),
      startY: 110,
      showHead: 'firstPage',
      styles: { overflow: 'hidden' },
      margin: { right: 107 },
    });

    doc.autoTable({
      columns: [
        { dataKey: 'currency', header: '' },
        { dataKey: 'amount', header: '' },
      ],
      body: bodyRowsMiddleTwo(),
      startY: 110,
      showHead: 'firstPage',
      styles: { overflow: 'hidden' },
      margin: { left: 107 },
    });

    doc.autoTable({
      columns: [
        { dataKey: 'currency', header: '' },
        { dataKey: 'amount', header: '' },
      ],
      body: bodyRowsLastTableOne(),
      startY: 160,
      showHead: 'firstPage',
      styles: { overflow: 'hidden' },
      margin: { right: 107 },
      didDrawPage: function (data) {
        // Footer
        var str = 'Página ' + doc.internal.getNumberOfPages()
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
          str = str + ' de ' + totalPagesExp
        }
        doc.setFontSize(10);

        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
        var pageSize = doc.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        doc.text(str, data.settings.margin.left, pageHeight - 10)
      },
    });

    doc.autoTable({
      columns: [
        { dataKey: 'currency', header: '' },
        { dataKey: 'amount', header: '' },
      ],
      body: bodyRowsLastTableTwo(),
      startY: 160,
      showHead: 'firstPage',
      styles: { overflow: 'hidden' },
      margin: { left: 107 },
    });

    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }

    doc.save("CorteDeCaja.pdf");
  }

  function bodyRowsCasher() {
    var body = []

    body.push({
      casher: "Cajero(a): " + casher.name,
      date: "Fecha: " + dateOne,
    });

    return body
  }

  function bodyRowsTableOneCurrency() {
    var body = []

    body.push({
      currency: "$ 1,000",
      amount: cashOut.oneThousand,
    });
    body.push({
      currency: "$ 500",
      amount: cashOut.fiveHundred,
    });
    body.push({
      currency: "$ 200",
      amount: cashOut.twoHundred,
    });
    body.push({
      currency: "$ 100",
      amount: cashOut.oneHundred,
    });
    body.push({
      currency: "$ 50",
      amount: cashOut.fifty,
    });
    body.push({
      currency: "$ 20",
      amount: cashOut.twenty,
    });

    return body
  }

  function bodyRowsTableTwoCurrency() {
    var body = []

    body.push({
      currency: "$ 10",
      amount: cashOut.ten,
    });
    body.push({
      currency: "$ 5",
      amount: cashOut.five,
    });
    body.push({
      currency: "$ 2",
      amount: cashOut.two,
    });
    body.push({
      currency: "$ 1",
      amount: cashOut.one,
    });
    body.push({
      currency: "$ .50",
      amount: cashOut.fiftyCent,
    });

    return body
  }

  function bodyRowsMiddleOne() {
    var body = []

    body.push({
      currency: "Fondo de caja",
      amount: currencyFormat(Number(cashOut != null ? cashOut.initialCashFund : 0)),
    });
    body.push({
      currency: "Ventas por membresías",
      amount: currencyFormat(Number(cashOut != null ? cashOut.salesByMembershipTotal : 0)),
    });
    body.push({
      currency: "Otras ventas",
      amount: currencyFormat(Number(cashOut != null ? cashOut.otherSalesTotal : 0)),
    });
    body.push({
      currency: "Otros ingresos",
      amount: currencyFormat(Number(cashOut != null ? cashOut.entryTotal : 0)),
    });

    return body
  }

  function bodyRowsMiddleTwo() {
    var body = []

    body.push({
      currency: "Compras",
      amount: currencyFormat(Number(cashOut != null ? cashOut.purchaseTotal : 0)),
    });
    body.push({
      currency: "Gastos",
      amount: currencyFormat(Number(cashOut != null ? cashOut.egressTotal : 0)),
    });

    return body
  }

  function bodyRowsLastTableOne() {
    var body = []

    body.push({
      currency: "Total de efectivo",
      amount: currencyFormat(Number(cashOut != null ? cashOut.totalCash : 0)),
    });
    body.push({
      currency: "Total de vouchers",
      amount: currencyFormat(Number(cashOut != null ? cashOut.totalVoucher : 0)),
    });
    body.push({
      currency: "Total por comisiones",
      amount: currencyFormat(Number(cashOut != null ? cashOut.totalCommission : 0)),
    });
    body.push({
      currency: "Total por transferencia",
      amount: currencyFormat(Number(cashOut != null ? cashOut.totalTransfer : 0)),
    });

    return body
  }

  function bodyRowsLastTableTwo() {
    var body = []

    body.push({
      currency: "Reporte de caja",
      amount: currencyFormat(Number(cashOut != null ? cashOut.reportCash : 0)),
    });
    body.push({
      currency: "Total (ingresos - egresos)",
      amount: currencyFormat(Number(cashOut != null ? cashOut.total : 0)),
    });
    body.push({
      currency: "Diferencia",
      amount: currencyFormat(Number(cashOut != null ? cashOut.difference : 0)),
    });

    return body
  }

  const handleChange = (e) => {
    const value = e.target.value;
    if (value != '') {
      var name = '';

      allCasher.map((option) => {
        if (option.id == value) {
          name = option.name;
        }
      });

      setCasher({ ...casher, id: value, name: name });
    } else {
      setCasher({ ...casher, id: '', name: '' });
    }
  }

  return (
    <>
      <div>
        {showModal ? (
          <Modal
            isOpen={showModal}
            closeModal={closeModalLogin}
          />
        ) : (
          <></>
        )}

        <SnackbarMessage
          showSnackbar={showSnackbar}
          messageSnackbar={messageSnackbar}
          handleToClose={handleToClose}
          isError={errorSnackbar}
        />

        {isLoading ? (
          <CircularProgress size={26} className={classes.loginLoader} />
        ) : (
          <div style={{ height: "100%" }}>
            <PageTitle title="Corte de caja" />

            <div className={classesTable.divCardSaleDos}>

              <div style={{ marginTop: "15px", marginBottom: "15px" }}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "25px", textAlign: "justify", backgroundColor: "#fff", borderRadius: "4px" }}>
                  <div style={{ display: "flex", alignItems: "center", textAlign: "justify", width: "40%" }}>
                    <div style={{ width: "90%" }}>
                      <text style={{ color: "#000", marginLeft: "24px" }}>Cajero(a)</text>
                      <FormControl className={classes.formControl}>
                        <Select
                          onChange={handleChange}
                          displayEmpty
                          value={casher.id}
                          style={{ color: "#000", marginLeft: "24px" }}
                        >
                          <MenuItem value=""> Selecciona </MenuItem>
                          {allCasher.map((option) => (
                            <MenuItem value={option.id}>{option.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", textAlign: "justify", width: "40%" }}>
                    <div>
                      <label className={classes.labelDate} >Fecha</label>
                      <TextField
                        type="date"
                        className={classes.inputDate}
                        onChange={onChangeDateOne}
                        style={{ width: '85%' }}
                        inputStyle={{ width: '85%' }}
                      />
                    </div>
                    <button
                      className={classes.enableButtonDate}
                      onClick={onClickRange}
                    >Buscar</button>

                    <div style={{ height: "50px", width: "2px", backgroundColor: "#E0E0E0", margin: "auto", marginLeft: "30px", marginRight: "30px" }} />
                  </div>

                  <div style={{ display: "flex", alignItems: "center", textAlign: "justify", width: "20%" }}>
                    <IconButton
                      onClick={onClickSave}
                      className={classes.enableButtonDate}
                    >
                      <Download style={{ marginRight: "8px" }} />
                      Descargar
                    </IconButton>
                  </div>
                </div>
              </div>

              <div id="tablePrint" style={{ alignItems: "center", justify: 'center', textAlign: "right", backgroundColor: "#fff", borderRadius: "4px", padding: '16px', width: "100%", height: "100%" }}>
                <div className={classes.divColumn}>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText}>DENOMINACIÓN</text>
                    <text className={classes.divDenominationCashText}>CANTIDAD</text>
                  </div>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText}>DENOMINACIÓN</text>
                    <text className={classes.divDenominationCashText}>CANTIDAD</text>
                  </div>

                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText}>$ 1,000</text>
                    <text className={classes.divDenominationCashText}>{cashOut != null ? cashOut.oneThousand : 0}</text>
                  </div>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText}>$ 10</text>
                    <text className={classes.divDenominationCashText}>{cashOut != null ? cashOut.ten : 0}</text>
                  </div>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText}>$ 500</text>
                    <text className={classes.divDenominationCashText}>{cashOut != null ? cashOut.fiveHundred : 0}</text>
                  </div>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText}>$ 5</text>
                    <text className={classes.divDenominationCashText}>{cashOut != null ? cashOut.five : 0}</text>
                  </div>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText}>$ 200</text>
                    <text className={classes.divDenominationCashText}>{cashOut != null ? cashOut.twoHundred : 0}</text>
                  </div>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText}>$ 2</text>
                    <text className={classes.divDenominationCashText}>{cashOut != null ? cashOut.two : 0}</text>
                  </div>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText}>$ 100</text>
                    <text className={classes.divDenominationCashText}>{cashOut != null ? cashOut.oneHundred : 0}</text>
                  </div>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText}>$ 1</text>
                    <text className={classes.divDenominationCashText}>{cashOut != null ? cashOut.one : 0}</text>
                  </div>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText}>$ 50</text>
                    <text className={classes.divDenominationCashText}>{cashOut != null ? cashOut.fifty : 0}</text>
                  </div>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText}>$ .50</text>
                    <text className={classes.divDenominationCashText}>{cashOut != null ? cashOut.fiftyCent : 0}</text>
                  </div>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText}>$ 20</text>
                    <text className={classes.divDenominationCashText}>{cashOut != null ? cashOut.twenty : 0}</text>
                  </div>
                </div>
                <br />

                <div className={classes.divColumn}>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText} style={{ textAlign: "right" }}>Fondo de caja</text>
                    <text className={classes.divDenominationCashText}>{currencyFormat(Number(cashOut != null ? cashOut.initialCashFund : 0))}</text>
                  </div>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText} style={{ textAlign: "right" }}>Compras</text>
                    <text className={classes.divDenominationCashText}>{currencyFormat(Number(cashOut != null ? cashOut.purchaseTotal : 0))}</text>
                  </div>

                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText} style={{ textAlign: "right" }}>Ventas por membresías</text>
                    <text className={classes.divDenominationCashText}>{currencyFormat(Number(cashOut != null ? cashOut.salesByMembershipTotal : 0))}</text>
                  </div>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText} style={{ textAlign: "right" }}>Gastos</text>
                    <text className={classes.divDenominationCashText}>{currencyFormat(Number(cashOut != null ? cashOut.egressTotal : 0))}</text>
                  </div>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText} style={{ textAlign: "right" }}>Otras ventas</text>
                    <text className={classes.divDenominationCashText}>{currencyFormat(Number(cashOut != null ? cashOut.otherSalesTotal : 0))}</text>
                  </div>
                  <div className={classes.divDenominationCash}>
                  </div>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText} style={{ textAlign: "right" }}>Otros ingresos</text>
                    <text className={classes.divDenominationCashText}>{currencyFormat(Number(cashOut != null ? cashOut.entryTotal : 0))}</text>
                  </div>
                </div>
                <br />

                <div className={classes.divColumn}>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText} style={{ textAlign: "right" }}>Total de efectivo</text>
                    <text className={classes.divDenominationCashText}>{currencyFormat(Number(cashOut != null ? cashOut.totalCash : 0))}</text>
                  </div>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText} style={{ textAlign: "right" }}>Reporte de caja</text>
                    <text className={classes.divDenominationCashText}>{currencyFormat(Number(cashOut != null ? cashOut.reportCash : 0))}</text>
                  </div>

                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText} style={{ textAlign: "right" }}>Total de vouchers</text>
                    <text className={classes.divDenominationCashText}>{currencyFormat(Number(cashOut != null ? cashOut.totalVoucher : 0))}</text>
                  </div>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText} style={{ textAlign: "right" }}>Total (ingresos - egresos)</text>
                    <text className={classes.divDenominationCashText}>{currencyFormat(Number(cashOut != null ? cashOut.total : 0))}</text>
                  </div>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText} style={{ textAlign: "right" }}>Total por comisiones</text>
                    <text className={classes.divDenominationCashText}>{currencyFormat(Number(cashOut != null ? cashOut.totalCommission : 0))}</text>
                  </div>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText} style={{ textAlign: "right" }}>Diferencia</text>
                    <text className={classes.divDenominationCashText}>{currencyFormat(Number(cashOut != null ? cashOut.difference : 0))}</text>
                  </div>
                  <div className={classes.divDenominationCash}>
                    <text className={classes.divDenominationCashText} style={{ textAlign: "right" }}>Total por transferencias</text>
                    <text className={classes.divDenominationCashText}>{currencyFormat(Number(cashOut != null ? cashOut.totalTransfer : 0))}</text>
                  </div>
                </div>
                <br />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default CashOutReport;
